import type { CSSProperties, ReactNode } from 'react';

/** Outer slip table (shared by MIXT / FitCrunch chrome + default slip). */
export const PACKING_SLIP_MAIN_TABLE_STYLE: CSSProperties = {
    fontFamily: '"Source Sans Pro", sans-serif',
    fontSize: 12,
    color: '#000000',
    margin: '0 auto',
    padding: 0,
    width: '100%',
    background: '#FFFFFF',
    textAlign: 'left',
    borderCollapse: 'collapse',
    maxWidth: '100%',
    wordBreak: 'break-word',
};

/** Nested line-items grid (MIXT 6-column table). */
export const PACKING_SLIP_INNER_SEPARATE_TABLE_STYLE: CSSProperties = {
    margin: 0,
    padding: 0,
    textAlign: 'left',
    borderCollapse: 'separate',
    width: '100%',
    borderSpacing: '2px',
};

interface PackingSlipPrintTableShellProps {
    children: ReactNode;
}

/** `print-wrapper` + `packing-slip-peel-main` with shared thermal table styles. */
export function PackingSlipPrintTableShell({ children }: PackingSlipPrintTableShellProps) {
    return (
        <div className="print-wrapper">
            <table className="packing-slip-peel-main" aria-hidden="true" style={PACKING_SLIP_MAIN_TABLE_STYLE}>
                {children}
            </table>
        </div>
    );
}
